import * as React from 'react';
import { FunctionComponent } from 'react';
import './TimeIntervalField.css';
import { DATE_INTERVAL } from 'Src/consts/table';
import MaskedInput from 'react-text-mask';

interface Props {
  onTableFilterChange: (event, value: string, options?) => void;
  field: string;
  from: string;
  to: string;
  onEnterPress?: (event) => void;
}

export const TimeIntervalField: FunctionComponent<Props> = props => {
  const { onEnterPress } = props;

  return (
    <div className={'mMinWidth170 mMaxWidth250'}>
      <div className="input-group mMarginBottom4">
        <div className="input-group-prepend">
          <span className="input-group-text mMinWidth60">From:</span>
        </div>
        <MaskedInput
          type="text"
          className="form-control mMaxWidth80"
          onChange={event => {
            props.onTableFilterChange(event, props.field, DATE_INTERVAL.FROM);
          }}
          onKeyDown={onEnterPress}
          mask={[/\d/, /\d/, ':', /\d/, /\d/]}
          placeholder="HH:MM"
          value={props.from}
        />
      </div>
      <div className="input-group">
        <div className="input-group-prepend">
          <span className="input-group-text mMinWidth60">To:</span>
        </div>
        <MaskedInput
          type="text"
          className="form-control mMaxWidth80"
          onChange={event => {
            props.onTableFilterChange(event, props.field, DATE_INTERVAL.TO);
          }}
          onKeyDown={onEnterPress}
          mask={[/\d/, /\d/, ':', /\d/, /\d/]}
          placeholder="HH:MM"
          value={props.to}
        />
      </div>
    </div>
  );
};

TimeIntervalField.displayName = 'TimeIntervalField';
